import { useRef, useEffect, useCallback, useState } from "react";
import { useField } from "formik";
import Editor from "@monaco-editor/react";
import { makeStyles } from "@material-ui/styles";
import { FormHelperText, InputLabel } from "@material-ui/core";
import clsx from "clsx";
import { checkFormValidity } from "../../../src/utils/helpers";
import { WorkflowErrors } from "../../App";
import React from "react";

const useStyles = makeStyles({
  wrapper: {
    width: "100%",
  },
  monaco: {
    padding: 10,
    width: "100%",
    borderColor: "rgba(128, 128, 128, 0.2)",
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: "rgb(255, 255, 255)",
    "&:focus-within": {
      margin: -2,
      borderColor: "rgb(73, 105, 228)",
      borderStyle: "solid",
      borderWidth: 2,
    },
  },
  label: {
    display: "block",
    marginBottom: 8,
  },
});

export default function ({
  className,
  editorId,
  label,
  height,
  reinitialize = false,
  defaultLanguage,
  onChange,
  onJsonError,
  // jsTabChanged,
  // onJsTabClear,
  ...props
}) {
  const classes = useStyles();
  const [field, meta, helper] = useField(props);
  const editorRef = useRef(null);

  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);
  const [jsonErrors, setJsonErrors] = useState([]);
  const [isEditorMounted, setIsEditorMounted] = useState(false);

  React.useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  function handleEditorMount(editor) {
    editorRef.current = editor;
    editor.onDidBlurEditorText(() => {
      helper.setValue(editorRef.current.getValue());
    });
  }

  const handleValidate = (markers) => {
    setJsonErrors(markers);
    setIsEditorMounted(true);
    // onJsonError(markers);
  };

  const handleEditorChange = useCallback(
    (value, event) => {
      handleChange(value, event, editorId);
    },
    [editorId]
  );

  const handleChange = useCallback(
    (value, event) => {
      onChange(value, event, editorId);
    },
    [editorId]
  );

  useEffect(() => {
    if (reinitialize && editorRef?.current?.getModel) {
      editorRef.current.getModel().setValue(field.value);
    }
  }, [reinitialize, field.value]);

  return (
    <div className={clsx([classes.wrapper, className])}>
      <InputLabel
        style={{ color: "#000000", marginBottom: "4px" }}
        error={meta.touched && !!meta.error}>
        {label}
      </InputLabel>

      <Editor
        id={`${editorId}`}
        className={classes.monaco}
        height={height || 90}
        language={defaultLanguage}
        onMount={handleEditorMount}
        onValidate={handleValidate}
        onChange={(value, event) => handleEditorChange(value, event)}
        defaultValue={field.value}
        options={{
          tabSize: 2,
          minimap: { enabled: false },
          lightbulb: { enabled: false },
          quickSuggestions: false,

          lineNumbers: "off",
          glyphMargin: false,
          folding: false,
          // Undocumented see https://github.com/Microsoft/vscode/issues/30795#issuecomment-410998882
          lineDecorationsWidth: 0,
          lineNumbersMinChars: 0,
          renderLineHighlight: "none",

          overviewRulerLanes: 0,
          hideCursorInOverviewRuler: true,
          scrollbar: {
            vertical: "hidden",
          },
          overviewRulerBorder: false,
        }}
      />

      {meta.touched && meta.error ? (
        <FormHelperText variant="outlined" error>
          {meta.error}
        </FormHelperText>
      ) : null}
    </div>
  );
}
